import { isUndefined } from '@aloft/toolkit-shared';

import { FileUploader } from '../../../components/FileUploader.tsx';

type QAFileUploaderProps = {
  id: string;
  field: {
    value: File | undefined;
    onChange: (event: File | React.ChangeEvent<Element>) => void;
  };
  type: 'xml' | 'pdf';
};

export function UploadDocumentsFileUploader({ id, field, type }: QAFileUploaderProps) {
  const file = field.value;
  const files = isUndefined(file)
    ? []
    : [
        {
          name: file.name,
          id: file.name,
          blobID: undefined,
        },
      ];

  return (
    <FileUploader
      id={id}
      maxFiles={1}
      files={files}
      onFileAdd={(file) => field.onChange(file)}
      accept={type === 'xml' ? { 'text/xml': ['.xml'] } : { 'application/pdf': ['.pdf'] }}
    />
  );
}
